import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Comment } from 'sharedTypes/client';
import { FirebaseService } from 'src/app/services/firebase.service';
import { StateService } from 'src/app/services/state.service';

@Component({
    selector: 'app-edit-comment',
    templateUrl: './edit-comment.component.html',
    styleUrls: ['./edit-comment.component.scss'],
    standalone: false,
})
export class EditCommentComponent implements OnInit {
    textNummers = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

    constructor(
        public dialogRef: MatDialogRef<EditCommentComponent>,
        public stateService: StateService,
        private firebaseService: FirebaseService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            comment: Comment;
        },
    ) {}

    ngOnInit(): void {}

    save() {
        this.dialogRef.close(this.data.comment);
    }

    addText(index: string) {
        const ts = this.stateService.sharedSettings.getValue().savedNotizTexts || {};
        if (ts[index]) {
            this.data.comment.text = this.data.comment.text + ts[index];
        }
    }

    async saveText(index: string) {
        const ts = this.stateService.sharedSettings.getValue().savedNotizTexts || {};
        ts[index] = this.data.comment.text;
        await this.firebaseService.setSavedNotizTexts(ts);
    }
}
